import Link from 'next/link';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { CtaButton as CommonBtn } from '@packages/common-ui/components/CtaButton';
import { mq } from '@farawaygg/common/constants/breakpoints.constants';
import { Typography } from 'common-ui/components/Typography';
export const PulsarAnimation = css`
  animation: blick 2s ease-in-out infinite;

  @keyframes blick {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }
`;
export const WhiteColor = css`
  color: var(--Game-Oslo);
`;
export const BlackColor = css`
  color: #a8b2de;
`;
export const Coanda = css`
  font-family: Coanda;
`;
export const Chakra = css`
  font-family: 'Chakra Petch';
`;
export const Text = styled.span`
  font-family: Coanda;
  display: block;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
`;
export const TextH2 = styled(Text)`
  font-size: 32px;
`;
export const TextH3 = styled(Text)`
  font-size: 27px;
`;
export const TextH5 = styled(Text)`
  font-size: 18px;
  font-weight: 400;
`;
export const TextH7 = styled(Text)`
  font-size: 14px;
  font-weight: 400;
`;
export const TextS = styled(Text)`
  font-size: 40px;

  ${mq.tabletHorizontal} {
    font-size: 32px;
  }

  ${mq.mobile} {
    font-size: 24px;
  }
`;
export const TextM = styled(Text)`
  font-size: 60px;

  ${mq.tabletHorizontal} {
    font-size: 40px;
  }

  ${mq.mobile} {
    font-size: 32px;
  }
`;
export const TextL = styled(Text)`
  font-size: 100px;

  ${mq.tabletHorizontal} {
    font-size: 60px;
  }

  ${mq.mobile} {
    font-size: 32px;
  }
`;
export const Button = styled(CommonBtn)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  /* font-size: 18px; */
`;
export const BlackLabel = styled.div`
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  font-family: 'Chakra Petch';
  align-items: center;
  border-radius: 50px;
  border: 2px solid #a8b2de;
  width: fit-content;
  color: #a8b2de;
  font-size: 18px;
`;
export const RobotBG = styled.div`
  position: absolute;
  width: 100%;
  height: 1080px;
  background: url('/assets/main-landing/first-section-bg.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: inset 0 -60px 50px #0f0e1c;

  ${mq.tabletHorizontal} {
    height: 576px;
  }
`;
export const CreaturesBG = styled.div`
  position: absolute;
  width: 1920px;
  height: 1080px;
  background: url('/assets/main-landing/first-section-bg-mara.webp');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  top: 0;
  left: 50%;
  transform: translateX(-50%);

  ${mq.tabletHorizontal} {
    width: 1024px;
    height: 580px;
  }

  animation: bounceMara 2s ease-in-out infinite;

  @keyframes bounceMara {
    0% {
      transform: translate(-50%, 0);
    }
    50% {
      transform: translate(-50%, 20px);
    }
    100% {
      transform: translate(-50%, 0);
    }
  }
`;
export const HeadingWrapper = styled.div`
  position: relative;
  height: 1380px;
  text-align: center;
  max-width: 1077px;
  padding: 990px 0px 0;
  margin: 0 auto 264px auto;

  ${mq.tabletHorizontal} {
    height: 820px;
    padding: 409px 160px 0;
    margin-bottom: 84px;
  }

  ${mq.tabletVertical} {
    height: 820px;
    padding: 410px 50px 0;
  }

  ${mq.mobile} {
    height: 794px;
    padding: 407px 10px 0;
    margin-bottom: 0;
  }
`;
export const HeadingText = styled(TextL)`
  display: block;
  margin-bottom: 16px;
  text-transform: uppercase;

  ${mq.tabletHorizontal} {
    margin-bottom: 16px;
  }

  ${mq.mobile} {
    font-size: 30px;
    margin-bottom: 16px;
  }
`;
export const HeadingDesc = styled(Typography)`
  display: block;
  margin: 0 auto 16px;
  letter-spacing: unset;
  font-weight: 400;
  width: 487px;
  line-height: 150%;

  ${mq.mobile} {
    max-width: 340px;
  }
`;
export const LoopAnimationWrapper = styled.div`
  position: relative;
  display: flex;
  width: fit-content;
  animation: lineLoop 15s linear infinite;
  z-index: 10;

  @keyframes lineLoop {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }
`;
export const LineText = styled(Typography)`
  display: block;
  font-size: 200px !important;
  font-family: Coanda;
  line-height: 110%;
  text-wrap: nowrap;
  position: relative;
  flex-shrink: 0;
  color: #a8b2de;
  text-transform: uppercase;
  margin-right: 60px;

  ${mq.tabletHorizontal} {
    font-size: 100px !important;
    margin-right: 30px;
  }

  ${mq.mobile} {
    font-size: 60px !important;
    margin-right: 18px;
  }
`;
export const MachineBlick = styled.div`
  background-image: url('/assets/main-landing/blue-blick.webp');
  width: 100%;
  height: 1811px;
  position: absolute;
  background-size: cover;
  background-repeat: no-repeat;
  top: -546px;
  background-position-y: 70%;
  ${() => PulsarAnimation};

  ${mq.smallDesktop} {
    top: -246px;
    height: 1470px;
    background-position: 74% 70%;
  }
  ${mq.tabletHorizontal} {
    height: 1050px;
    background-size: contain;
    background-position: 50%;
  }
  ${mq.tabletVertical} {
    top: -270px;
    height: 960px;
    background-position: 50% 70%;
  }

  ${mq.mobile} {
    top: -270px;
    height: 910px;
    background-position: 50% 70%;
    background-size: 160%;
  }
`;
export const GetYourCreatureLink = styled(Link)`
  display: block;
  width: fit-content;
  margin: 26px auto 220px;
  position: relative;
  z-index: 10;

  ${mq.smallDesktop} {
    margin-bottom: 123px;
  }

  ${mq.tabletHorizontal} {
    margin: 25px auto 104px;
  }

  ${mq.mobile} {
    margin: 16px auto 104px;
  }
`;
export const WhiteLabel = styled.div`
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  border: 2px solid #fff;
  color: #fff;
  text-align: center;
  font-family: 'Chakra Petch';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  text-transform: uppercase;
`;
export const MachineWraper = styled.div`
  position: relative;
  max-width: 1024px;
  margin: auto;
  margin-top: 265px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: var(--Game-Oslo);
  text-align: center;
  font-family: 'Coanda';
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  text-transform: uppercase;

  ${mq.tabletHorizontal} {
    margin-top: 117px;
  }

  ${mq.mobile} {
    margin-top: 86px;
  }
`;
export const GreyBg = css`
  background: #0f0e1c;
  color: #a8b2de;
`;
export const DefendWrapper = styled.div`
  padding: 90px 0 140px;
  color: var(--Game-Tokyo);

  ${mq.smallDesktop} {
    padding: 187px 0 142px 0px;
  }

  ${mq.tabletHorizontal} {
    padding: 80px 0 62px;
  }

  ${mq.tabletVertical} {
    padding: 90px 0 80px;
  }

  ${mq.mobile} {
    padding: 0px 0 134px;
  }
`;
export const DefendRift = styled.div`
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  max-width: 1024px;

  ${mq.mobile} {
    flex-direction: column;
    gap: 40px;
  }
`;
export const DefendTitle = styled(TextM)`
  text-transform: uppercase;
  font-size: 60px;

  ${mq.tabletHorizontal} {
    font-size: 40px;
  }

  ${mq.mobile} {
    font-size: 30px;
  }
`;
export const DefendDescWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  ${mq.smallDesktop} {
    gap: 16px;
  }

  ${mq.tabletHorizontal} {
    max-width: 432px;
    margin-top: 0px;
  }

  ${mq.tabletVertical} {
    max-width: 329px;
    margin-top: -20px;
  }

  ${mq.mobile} {
    justify-content: center;
    text-align: center;
  }
`;
export const DefendDescText = styled(TextH5)`
  line-height: 150%;

  ${mq.mobile} {
    max-width: 320px;
  }
`;
export const DefRobotWrapper = styled.div`
  flex-shrink: 0;
  width: 448px;
  height: 552px;
  margin-left: 17px;
  margin-right: 87px;

  ${mq.tabletHorizontal} {
    width: 383.072px;
    height: 472px;
    margin-right: 74px;
  }

  ${mq.tabletVertical} {
    width: 291.588px;
    height: 359.278px;
    margin-right: 56px;
  }

  ${mq.mobile} {
    margin-right: 0;
  }
`;
export const KaijuWrapper = styled.div`
  width: 100%;
  height: 1080px;
  background-image: url('/assets/main-landing/enemy-bg.webp');
  background-size: cover;
  background-position: 70% 0;
  box-shadow: inset 0px -50px 100px #0f0e1c;

  ${mq.tabletHorizontal} {
    padding: 0 20px 0 33px;
    height: 860px;
    background-position: 71% 0;
  }

  ${mq.tabletVertical} {
    padding: 0 20px;
    height: 869px;
    background-position: 65% 0;
  }

  ${mq.mobile} {
    padding: 0;
    background-image: url('/assets/main-landing/enemy-bg-mobile.webp');
    background-position: center center;
    background-size: cover;
    height: 869px;
  }
`;
export const KaijuInnerWrapper = styled.div`
  max-width: 1024px;
  margin: auto;
`;
export const DefendersLabel = styled(WhiteLabel)`
  margin: 0 0 5px;
  text-transform: uppercase;

  ${mq.smallDesktop} {
    margin-bottom: 5px;
  }

  ${mq.tabletVertical} {
    margin-bottom: 10px;
  }

  ${mq.mobile} {
    margin: 0 auto 10px;
  }
`;
export const KaijuTitleWrapper = styled.div`
  display: flex;
  width: 648px;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding-top: 438px;
  padding-bottom: 62px;

  ${mq.smallDesktop} {
    gap: 0;
    padding-bottom: 58px;
  }

  ${mq.tabletHorizontal} {
    padding-top: 397px;
    padding-bottom: 57px;
  }

  ${mq.tabletVertical} {
    padding: 404px 0 52px 42px;
  }

  ${mq.mobile} {
    padding: 34px 0 15px 0;
    width: 100%;
  }
`;
export const KaijuTitle = styled(TextL)`
  color: var(--Game-Oslo);
  text-transform: uppercase;

  ${mq.tabletHorizontal} {
    margin-top: -5px;
  }

  ${mq.tabletVertical} {
    margin-bottom: 0px;
  }

  ${mq.mobile} {
    max-width: 340px;
    margin: auto;
    margin-bottom: 476px;
    text-align: center;
  }
`;
export const KaijuDescription = styled.div`
  width: 446px;

  ${mq.tabletVertical} {
    margin-left: 43px;
  }
  ${mq.mobile} {
    max-width: 340px;
    margin: auto;
  }
`;
export const KaijuDescriptionText = styled(TextH5)`
  display: block;
  margin-bottom: 20px;
  line-height: 150%;

  ${mq.tabletHorizontal} {
    margin-bottom: 23px;
  }

  ${mq.mobile} {
    text-align: center;
    margin-bottom: 8px;
  }
`;
export const GameSection = styled.div`
  background-color: #0f0e1c;
  padding: 95px 0 202px;
  box-shadow: 0px 40px 80px #0f0e1c;
  z-index: 10;
  position: relative;

  ${mq.tabletHorizontal} {
    padding: 67px 0 32px;
  }

  ${mq.tabletVertical} {
    padding: 40px 0 32px;
  }

  ${mq.mobile} {
    padding: 40px 0 54px;
  }
`;
export const CreateYourSuperTeamWrapper = styled.div`
  ${mq.smallDesktop} {
    margin-top: 10px;
  }

  ${mq.tabletHorizontal} {
    margin-top: 74px;
  }

  ${mq.tabletVertical} {
    margin-top: 82px;
  }

  ${mq.mobile} {
    margin-top: 0;
    padding-top: 113px;
  }
`;
export const ShadowWrapper = styled.div`
  box-shadow: 0px -90px 80px #0f0e1c;
  z-index: 10;
  position: relative;

  ${mq.mobile} {
    box-shadow: 0px -90px 60px #0f0e1c;
  }
`;
export const GameSectionTitleWrapper = styled.div`
  max-width: 1030px;
  margin: auto;
  text-align: center;
  margin-bottom: 90px;
  overflow: hidden;

  ${mq.mobile} {
    margin: auto;
    max-width: 340px;
    margin-bottom: 70px;
  }
`;
export const GameSectionTitle = styled(TextM)`
  margin: auto;
  padding: 0 10px;
  margin-bottom: 21px;
  text-align: center;
  text-transform: uppercase;

  ${mq.mobile} {
    font-size: 27px;
    margin-bottom: 17px;
  }
`;
export const GameSectionDesc = styled(TextH5)`
  margin: auto;
  padding: 0 10px;
  ${mq.mobile} {
    max-width: 340px;
    margin: auto;
    line-height: 150%;
  }
`;
export const YourHVMTLWrapper = styled.div`
  display: flex;
  justify-content: center;
  ${() => GreyBg};
`;
export const YourHVMTL = styled.div`
  display: inline-flex;
  width: 1024px;
  margin: auto;
  justify-content: center;
  align-items: center;
  gap: 59px;
  overflow: hidden;
  max-height: 832px;
  margin-bottom: 16px;

  ${mq.smallDesktop} {
    margin: 0;
    gap: 25px;
    justify-content: space-between;
  }

  ${mq.tabletHorizontal} {
    width: 870px;
  }

  ${mq.tabletVertical} {
    margin: 0 24px 0 33px;
    height: 685px;
    gap: 40px;
  }

  ${mq.mobile} {
    flex-direction: column;
    justify-content: start;
    padding-top: 60px;
    max-height: unset;
    height: 858px;
    margin: 0;
  }
`;
export const YourHVMTLLeft = styled.div`
  display: flex;
  width: 472px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  flex-shrink: 0;
  margin-top: -134px;

  ${mq.smallDesktop} {
    margin-top: -153px;
  }

  ${mq.tabletHorizontal} {
    width: 381px;
    margin-top: -4px;
    margin-left: 11px;
  }

  ${mq.tabletVertical} {
    width: 321px;
    margin-top: 12px;
    margin-left: 0px;
  }

  ${mq.mobile} {
    width: 321px;
    z-index: 10;
    box-shadow: 0px 110px 60px #0f0e1c;
  }
`;
export const YourHVMTLDesc = styled(TextH5)`
  line-height: 150%;
  ${mq.mobile} {
    text-align: center;
  }
`;
export const YourHVMTLLeftWrapper = styled.div`
  width: 472px;

  ${mq.tabletVertical} {
    width: auto;
  }
`;
export const YourHVMTRight = styled.div`
  width: fit-content;
  display: flex;
  overflow: hidden;
  gap: 35px;
  width: 493px;

  ${mq.tabletHorizontal} {
    margin-left: 47px;
  }

  ${mq.tabletVertical} {
    gap: 25px;
    margin-left: 0;
  }

  ${mq.mobile} {
    gap: 26px;
    width: 100%;
    justify-content: center;
    height: 450px;
  }
`;
export const AscMaterial1 = styled.div<{
  traverse: number;
}>`
  position: relative;
  width: 282.5px;
  height: 8000px;
  background-image: url('/assets/main-landing/loot-1.webp');
  background-size: contain;
  background-repeat: repeat-y;
  transition: all 0.1s linear;
  transition-duration: 0.1s;
  top: 370px;
  ${({
  traverse
}) => `transform: translateY(${traverse - 370}px)`};

  ${mq.smallDesktop} {
    width: 227px;
  }
  ${mq.tabletHorizontal} {
    top: -500px;
    width: 194px;
  }

  ${mq.tabletVertical} {
    width: 152px;
  }

  ${mq.mobile} {
    top: -1000px;
  }
`;
export const AscMaterial2 = styled.div<{
  traverse: number;
}>`
  position: relative;
  width: 282.5px;
  height: 6000px;
  background-image: url('/assets/main-landing/loot-2.webp');
  background-size: contain;
  background-repeat: repeat-y;
  top: -370px;
  ${({
  traverse
}) => `transform: translateY(${traverse + 370}px)`};
  transition: all 0.1s linear;
  transition-duration: 0.1s;

  ${mq.smallDesktop} {
    width: 227px;
  }

  ${mq.tabletHorizontal} {
    width: 194px;
  }

  ${mq.tabletVertical} {
    width: 152px;
  }

  ${mq.mobile} {
    top: -1500px;
  }
`;
export const GreenBlick = styled.div`
  background-image: url('/assets/main-landing/blue-blick.webp');
  width: 100%;
  height: 1526px;
  background-position: -7%;
  position: absolute;
  background-size: contain;
  background-repeat: no-repeat;
  top: 0;

  ${mq.smallDesktop} {
    height: 1248px;
    background-position: 63% center;
  }

  ${mq.tabletHorizontal} {
    height: 860px;
    background-position: 0% center;
  }

  ${mq.mobile} {
    height: 510px;
    background-size: 190%;
    background-position: 50% 120%;
  }
  ${() => PulsarAnimation};
`;
export const BouncingAnimationWrapper = styled.div`
  animation: bounce 2s ease-in-out infinite;

  @keyframes bounce {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(20px);
    }
    100% {
      transform: translateY(0);
    }
  }
`;
export const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${mq.mobile} {
    margin-top: 27px;
  }
`;
export const CardContent = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1611px;
  margin: 110px auto 60px;
  transform: scale(0.85);

  ${mq.smallDesktop} {
    margin: auto;
    margin-top: 220px;
    height: 580px;
  }

  ${mq.tabletHorizontal} {
    transform: scale(0.6);
    margin-top: 110px;
    height: 430px;
  }

  ${mq.mobile} {
    transform: scale(0.3);
    margin: auto;
    height: 200px;
  }
`;
export const CreateYourTeamWrapper = styled.div`
  margin-top: -50px;

  ${mq.smallDesktop} {
    margin-top: 45px;
  }

  ${mq.tabletHorizontal} {
    margin-top: 42px;
  }

  ${mq.mobile} {
    margin-top: 52px;
  }
`;
export const CreateYourTeamText = styled(TextH5)`
  position: relative;
  max-width: 620px;
  line-height: 150%;
  margin: 0 auto 30px;
  text-align: center;
  font-family: 'Chakra Petch';

  ${mq.tabletHorizontal} {
    margin-bottom: 22px;
  }

  ${mq.mobile} {
    max-width: 340px;
    margin-bottom: 17px;
  }
`;
export const RobotCard1 = styled.div`
  width: 290px;
  height: 392px;
  background-image: url('/assets/main-landing/card-1.webp');
  position: relative;
  transform: translate(270px, 80px) rotate(-30deg);
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0;
`;
export const RobotCard2 = styled.div`
  width: 388px;
  height: 523px;
  background-image: url('/assets/main-landing/card-2.webp');
  position: relative;
  transform: translate(150px, 0) rotate(-15deg);
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0;
`;
export const RobotCard3 = styled.div`
  width: 540px;
  height: 728px;
  background-image: url('/assets/main-landing/card-3.webp');
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0;
  z-index: 10;
`;
export const RobotCard4 = styled.div`
  width: 388px;
  height: 523px;
  background-image: url('/assets/main-landing/card-4.webp');
  position: relative;
  transform: translate(-160px, 0) rotate(15deg);
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0;
  z-index: 5;
`;
export const RobotCard5 = styled.div`
  width: 290px;
  height: 392px;
  background-image: url('/assets/main-landing/card-5.webp');
  position: relative;
  transform: translate(-280px, 80px) rotate(30deg);
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0;
  z-index: 0;
`;
export const CaseWrapper = styled.div`
  ${() => GreyBg}
  padding: 120px 0 200px;

  ${mq.smallDesktop} {
    padding: 195px 0 150px;
  }

  ${mq.tabletHorizontal} {
    padding: 82px 0 147px;
  }

  ${mq.tabletVertical} {
    padding: 146px 0 147px;
  }

  ${mq.mobile} {
    padding: 76px 0 134px;
  }
`;
export const CaseName = styled(TextH2)`
  width: fit-content;
  margin: 8px auto 16px;

  font-size: 40px;
  ${mq.tabletHorizontal} {
    font-size: 30px;
  }
`;
export const CaseDesc = styled(TextH5)`
  margin: auto;
  max-width: 620px;
  margin-bottom: 16px;
  text-align: center;
  min-height: 50px;
  width: fit-content;

  ${mq.mobile} {
    max-width: 340px;
    min-height: 65px;
  }
`;
export const GrayBlick = styled.div`
  background-image: url('/assets/main-landing/gray-blick.webp');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 1862px;
  height: 2367px;
  position: absolute;
  left: 50%;
  top: -30%;
  transform: translate(-50%, 0px);
  ${() => PulsarAnimation};

  ${mq.smallDesktop} {
  }

  ${mq.tabletHorizontal} {
    width: 1280px;
    height: 1627px;
    top: -37%;
  }
  ${mq.tabletVertical} {
    top: -39%;
  }

  ${mq.mobile} {
    width: 613.896px;
    height: 780.447px;
    top: -30%;
  }
`;
export const GrayBlickCreature = styled.div`
  background-image: url('/assets/main-landing/gray-blick.webp');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 1862px;
  height: 2367px;
  position: absolute;
  left: 50%;
  top: -55%;
  transform: translate(-50%, 0px);
  ${() => PulsarAnimation};

  ${mq.smallDesktop} {
  }

  ${mq.tabletHorizontal} {
    width: 1280px;
    height: 1627px;
    top: -59%;
  }
  ${mq.tabletVertical} {
    top: -77%;
  }

  ${mq.mobile} {
    width: 614px;
    height: 780px;
    top: -35%;
  }
`;
export const DefKaijuWrapper = styled.div`
  padding: 190px 0 96px;
  background-image: url('/assets/main-landing/def-bg.webp');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center 60%;

  ${mq.smallDesktop} {
    background-position: center 30%;
    padding: 100px 0;
  }

  ${mq.tabletVertical} {
    background-position: 50% 20%;
  }

  @media screen and (max-width: 430px) {
    background-position: 50% 16%;
    background-size: 280%;
  }

  ${mq.mobile} {
    padding: 30px 0;
  }
`;
export const DefKaijuContent = styled.div`
  margin: auto;
`;
export const DefKaijuName = styled(TextH2)`
  font-size: 40px;
  margin-bottom: 16px;
  ${mq.mobile} {
    font-size: 24px;
  }
`;
export const FaqWrapper = styled.div`
  padding: 132px 0 212px;
  background-image: url('/assets/main-landing/faq-bg.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow:
    inset 0px 100px 100px #0f0e1c,
    inset 0px -100px 100px #0f0e1c;

  ${mq.mobile} {
    padding: 118px 0 146px;
  }
`;
export const FaqTittle = styled(TextM)`
  margin-bottom: 16px;
  text-transform: uppercase;

  ${mq.mobile} {
    font-size: 40px;
    max-width: 340px;
    display: block;
    margin: 0 auto 16px;
  }
`;
export const FaqText = styled(TextH5)`
  line-height: 150%;
  margin: 0 auto 16px;

  ${mq.mobile} {
    max-width: 340px;
  }
`;
export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
`;
export const FooterWrapper = styled.div`
  width: calc(100% - 62px);
  min-height: 496px;
  margin: 31px;
  background-image: url('/assets/main-landing/footer-bg.webp');
  border-radius: 20px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 30px;

  ${mq.tabletVertical} {
    width: 100%;
    border-radius: 0;
    margin: 0;
    padding: 30px;
  }

  ${mq.mobile} {
    padding: 0;
  }
`;
export const FooterLink = styled(Link)`
  display: block;
  width: fit-content;
  margin: auto;
  &:hover {
    color: #00c6bb;
  }
  font-weight: 400 !important;
`;
export const SecondaryFooterLink = styled(Link)`
  display: block;
  width: fit-content;
  color: rgba(255, 255, 255, 0.5);
  &:hover {
    color: #00c6bb;
  }
  ${mq.tabletVertical} {
    margin: auto;
  }
`;
export const YellowRobot = styled.div`
  width: 796px;
  height: 796px;
  background-image: url('/assets/main-landing/green-mara.webp');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: -370px;
  right: -140px;

  @media (min-width: 1024px) and (max-width: 1280px) {
    right: -190px;
    top: -370px;
  }

  ${mq.tabletHorizontal} {
    right: -290px;
    top: -370px;
  }

  ${mq.tabletVertical} {
    display: none;
  }
`;
export const FooterContent = styled.div`
  z-index: 10;
  min-width: 440px;
  margin: auto;
  margin-top: 0;
  height: 496px;

  ${mq.tabletVertical} {
    height: auto;
  }

  ${mq.mobile} {
    min-width: unset;
    margin-bottom: 33px;
  }
`;
export const PinkRobot = styled.div`
  width: 749px;
  height: 749px;
  background-image: url('/assets/main-landing/pink-mara.webp');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: -360px;
  left: -130px;

  @media (min-width: 1024px) and (max-width: 1280px) {
    left: -190px;
    top: -360px;
  }

  ${mq.tabletHorizontal} {
    left: -260px;
    top: -360px;
  }

  ${mq.tabletVertical} {
    display: none;
  }
`;
export const CreatureWrapper = styled.div`
  margin: auto;
  ${mq.tabletHorizontal} {
    max-width: 869px;
  }
  ${mq.tabletVertical} {
    max-width: 658px;
  }
`;
export const CreatureWrapperText = styled(TextS)`
  margin-bottom: 30px;
  font-weight: 700;

  ${mq.tabletHorizontal} {
    font-size: 40px;
  }

  ${mq.tabletVertical} {
    font-size: 32px;
    margin: 0 10px 14px;
  }

  ${mq.mobile} {
    max-width: 340px;
    font-size: 24px;
  }
`;
export const CaruselFirst = styled.div`
  .swiper {
    width: 100%;
  }
  .swiper-slide {
    opacity: 0.4;
    filter: blur(5px);
    width: 800px;
    height: 800px;
  }
  .swiper-slide-next,
  .swiper-slide-prev {
    opacity: 0.6;
  }
  .swiper-slide-active {
    opacity: 1;
    filter: none;
  }

  ${mq.tabletHorizontal} {
    .swiper-slide {
      width: 427px;
      height: 427px;
    }
  }

  ${mq.tabletVertical} {
    .swiper-slide {
      width: 320px;
      height: 320px;
    }
  }

  ${mq.mobile} {
    .swiper-slide {
      width: 220px;
      height: 220px;
    }
  }
`;
export const C1Slide1 = styled.div`
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
export const CaruselSecond = styled.div`
  position: relative;
  z-index: 20;

  .swiper-wrapper {
    align-items: center;
  }
  .swiper-slide {
    opacity: 0.1;
    width: 400px;
    height: 400px;
  }
  .swiper-slide-visible {
    opacity: 0.25;
  }
  .swiper-slide-next,
  .swiper-slide-prev {
    opacity: 0.5;
  }
  .swiper-slide-active {
    opacity: 1;
    filter: none;
  }

  ${mq.tabletHorizontal} {
    .swiper-slide {
      width: 215px;
      height: 215px;
    }
  }

  ${mq.mobile} {
    .swiper-slide {
      width: 145px;
      height: 145px;
    }
  }
`;
export const CaruselThirdDesc = styled(TextH5)`
  width: fit-content;
  min-height: 90px;
  text-align: center;
  margin: auto;
  line-height: 150%;
  max-width: 620px;
  padding-bottom: 16px;

  ${mq.mobile} {
    max-width: 340px;
    min-height: 178px;
  }
`;
export const CaruselThird = styled.div`
  .swiper-wrapper {
    align-items: center;
  }
  .swiper-slide {
    width: 400px;
    height: 400px;
    z-index: 1;
    opacity: 0;
  }
  .swiper-slide-visible {
    opacity: 1;
  }
  .swiper-slide-next,
  .swiper-slide-prev {
    z-index: 5;
  }
  .swiper-slide-active {
    z-index: 10;
  }

  ${mq.tabletHorizontal} {
    .swiper-slide {
      width: 250px;
      height: 250px;
    }
  }
  ${mq.tabletVertical} {
    .swiper-slide {
      width: 194px;
      height: 194px;
    }
  }

  ${mq.mobile} {
    .swiper-slide {
      width: 180px;
      height: 180px;
    }
  }
`;